import React from 'react'

import Loader from 'react-loader-spinner'

import { Status } from 'components/map/PlaceSearch'

import useI18n from 'i18n/useI18n'

import ItineraryNav from 'map/ItineraryNav'
import { RouteResult } from 'map/visioweb'

import styled from 'theme/styled-components'
import useTheme from 'theme/useTheme'
import Button from 'components/button/Button'

interface Props {
  itineraryStatus: Status
  itineraryInfo?: RouteResult
  itinerary: any
  cancelItinerary: () => void
}

const TotemItinerary = ({ itineraryStatus, itineraryInfo, itinerary, cancelItinerary }: Props) => {
  const [theme] = useTheme()
  const i18n = useI18n()

  const [navStep, setNavStep] = React.useState(-1)
  const navSteps = React.useMemo(() => (itinerary.nav ? itinerary.nav.getNbInstructions() : 0), [itinerary.nav])
  const navInstructions = React.useMemo(
    () =>
      !!itinerary.nav ? Array.from(new Array(navSteps)).map((_, idx) => itinerary.nav?.getInstructionData(idx)) : [],
    [itinerary.nav, navSteps]
  )

  const currentNavStep = navInstructions[navStep]

  React.useEffect(() => {
    if (itinerary.nav) {
      setNavStep(0)
    } else {
      setNavStep(-1)
    }
  }, [itinerary.nav])

  const navNext = () => {
    if (itinerary.nav && navStep < navSteps - 1) {
      itinerary.nextRoute()
      setNavStep(navStep + 1)
    }
  }

  const navPrevious = () => {
    if (itinerary.nav && navStep > 0) {
      itinerary.previousRoute()
      setNavStep(navStep - 1)
    }
  }

  return (
    <NavigationContainer>
      {itineraryStatus === 'loading' ? (
        <Loader type="Grid" color={theme.colors.blue} height={150} width={150} />
      ) : itineraryStatus === 'ready' && itineraryInfo ? (
        <ItineraryNav
          itineraryInfo={itineraryInfo}
          current={currentNavStep}
          step={navStep}
          steps={navSteps}
          previous={navPrevious}
          next={navNext}
          sizeMultiplier={3}
        />
      ) : (
        <ErrorContainer>
          <ErrorMessage>{i18n.t('screens.cartography.totem.itineraryError')}</ErrorMessage>
          <Button fontSize={36} verticalPadding={28} label="Annuler" onClick={cancelItinerary} />
        </ErrorContainer>
      )}
    </NavigationContainer>
  )
}

export default TotemItinerary

const NavigationContainer = styled('div')`
  display: flex;
  width: 80%;
  height: fit-content;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  margin: 0 auto;
  padding: 0 80px;
  border-radius: 20px;
  background-color: ${(props) => props.theme.colors.white};
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
`

const ErrorContainer = styled('div')`
  display: flex;
  flex: 1;
  align-items: center;
  flex-direction: column;
  padding: 40px;
  gap: 40px;
`

const ErrorMessage = styled('p')`
  ${(props) => props.theme.fonts.totemLight};
  font-size: 40px;
  color: ${(props) => props.theme.colors.black};
  text-align: center;
  margin: 0;
`
